import React, { useState } from 'react';

const ExpandableText = ({ text, maxLength = 150, className = "" }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!text) return null;

    if (text.length <= maxLength) {
        return <p className={`text-white mb-3 whitespace-pre-wrap ${className}`}>{text}</p>;
    }

    return (
        <div className="mb-3">
            <p className={`text-white whitespace-pre-wrap inline ${className}`}>
                {isExpanded ? text : `${text.substring(0, maxLength)}...`}
            </p>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    setIsExpanded(!isExpanded);
                }}
                className="ml-1 text-gray-400 hover:text-white text-sm font-medium hover:underline focus:outline-none"
            >
                {isExpanded ? 'Daha az gör' : 'Devamını gör'}
            </button>
        </div>
    );
};

export default ExpandableText;
